import type {Component} from "vue";
import DemoApp from "@/DemoApp.vue";
import Loader from "@/components/Loader.vue";
import PalkLogoColor from "@/components/PalkLogoColor.vue";
import LanguageSelection from "@/components/LanguageSelection.vue";
import LoginBanner from "@/features/login-banner/LoginBanner.vue";
import AdminPage from "@/pages/admin/AdminPage.vue";

class MvcVueIntegration {

	private readonly components: Record<string, Component> = {};
	constructor() {
		this.components = {
			// "sign-in": SignIn,
            "demo-app": DemoApp,
			"loader": Loader,
			"palk-logo-color": PalkLogoColor,
			"language-selection": LanguageSelection,
			"login-banner": LoginBanner,
			"admin-page": AdminPage
		};
	}
	getComponents = (): Record<string, Component> => this.components;
}

const mvcVueIntegration = new MvcVueIntegration();
export default mvcVueIntegration;


